// extracted by mini-css-extract-plugin
export var addButton = "_ef-4";
export var contentBlockImage = "_ef-i";
export var contentBlockWidgetPreview = "_ef-g";
export var fulfillmentCutoffWidgetPreview = "_ef-9";
export var imageBackdrop = "_ef-6";
export var imageIcon = "_ef-8";
export var lowProfileImageContainer = "_ef-b";
export var lowProfileImageIcon = "_ef-f";
export var lowProfileImageIconContainer = "_ef-e";
export var lowProfileImagePlaceholder = "_ef-d";
export var lowProfileProductImage = "_ef-c";
export var lowProfileProductUpsellWidgetPreview = "_ef-a";
export var productCard = "_ef-5";
export var productImage = "_ef-7";
export var productReviewsWidgetPreview = "_ef-h";
export var progressBar = "_ef-1";
export var progressBarFill = "_ef-2";
export var progressBarTrack = "_ef-3";
export var shippingOptionWidgetPreview = "_ef-j";
export var shippingUpsellProgressBar = "_ef-k";
export var thresholdUpsellWidgetPreview = "_ef-0";